const CLOUDINARY_URL_PATTERN = 'res.cloudinary.com/';
const CLOUDINARY_PARAMS_PREFIX_PATTERN = 'upload/';

export const useImageOptimize = () => {
  const optimizeImage = (url?: string, size?: number, round: boolean = true) => {
    if (url?.includes(CLOUDINARY_URL_PATTERN)) {
      let params = 'f_auto/';
      if (round) {
        params += 'r_max/';
      }
      
      if (size) {
        if (url.match(/.*w_(\d+).*/)) {
          url = url.replace(/w_(\d+)/g, `w_${size}`);
        } else {
          params += `w_${size}/`;
        }

        if (url.match(/.*h_(\d+).*/)) {
          url = url.replace(/h_(\d+)/, `h_${size}`);
        } else {
          params += `h_${size}/`;
        }
      }

      return url.replace(CLOUDINARY_PARAMS_PREFIX_PATTERN, CLOUDINARY_PARAMS_PREFIX_PATTERN + params);
    }

    return url;
  }
  
  const optimizeAvatar = (url?: string, size?: number) => {
    return optimizeImage(url, size, true);
  }

  return { optimizeAvatar, optimizeImage }
}
